import jump from 'jump.js'

const getStuckHeight = () => {
    const $header = document.querySelector('.site-header')
    const $logo = $header.querySelector('.site-logo')
    const $pageAnchorNav = document.querySelector('.page-anchor-nav')

    let offest = 0

    if ($header) {
        if (window.matchMedia('(min-width: 1024px)').matches) {
            offest = $header.offsetHeight + 20
        } else {
            offest = $header.offsetHeight + $logo.offsetHeight / 4 + 20
        }
    }

    if ($pageAnchorNav) {
        offest += $pageAnchorNav.offsetHeight
    }

    return offest
}

const scrollTo = ($target, additionalOffset = 0) => {
    const headerOffset = getStuckHeight() * -1
    const offset = headerOffset - additionalOffset

    return new Promise((resolve) => {
        jump($target, { duration: 500, offset, callback: resolve })
    })
}

export default scrollTo
